import React from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'

import config from '../../../config'
import GooglePickerImage from '../../../modules/google-picker/GooglePickerImage'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { IMAGE_EDIT_MODAL } from '../../../constants/modalType'
import {
  UPDATE_BANNER_IMAGE_ITEM,
  ADD_BANNER_IMAGE_ITEM,
} from '../../../constants/actions'
import ImageSize from '../image-preview/ImageSize'

class BannerImage extends React.Component {
  static propTypes = {
    mainImageId: PropTypes.string,
    mainImageLastChecked: PropTypes.string,
    bannerID: PropTypes.string,
  }

  state = {
    imageRef: null,
  }

  handleImageRef = imageRef => {
    this.setState({
      imageRef,
    })
  }

  handleDropFile = e => {
    e.preventDefault()
    const files = e.target.files
    const imageFile = files[0]
    this.handleEditImageModelShow(imageFile)
  }

  handleImagePicked = imageFile => {
    this.handleEditImageModelShow(imageFile)
  }

  handleEditImageModelShow = imageFile => {
    if (imageFile) {
      this.props.modalActions.showModal(IMAGE_EDIT_MODAL, {
        bannerID: this.props.bannerID,
        imageFile,
        replaceImageID: this.props.mainImageId,
        action: this.props.mainImageId
          ? UPDATE_BANNER_IMAGE_ITEM
          : ADD_BANNER_IMAGE_ITEM,
        imageAspectRatio: 21 / 9,
      })
    } else {
      toast.error('image file not found.')
    }
  }

  render() {
    const { mainImageId, mainImageLastChecked } = this.props

    return (
      <div>
        {mainImageId && (
          <figure className="image">
            <img
              ref={this.handleImageRef}
              key={mainImageLastChecked || mainImageId}
              src={`${
                config.mainImageURLPrefix
              }/${mainImageId}?lastChecked=${mainImageLastChecked}`}
              alt={mainImageId}
            />
            <ImageSize imageRef={this.state.imageRef} />
          </figure>
        )}
        <div className="field">
          <div className="file is-info">
            <label className="file-label">
              <input
                className="file-input"
                type="file"
                name="files"
                onChange={this.handleDropFile}
              />
              <span className="file-cta">
                <span className="file-icon">
                  <i className="fas fa-upload" />
                </span>
                <span className="file-label">Local file…</span>
              </span>
            </label>
            <div style={{ marginLeft: 6 }}>
              <GooglePickerImage onImagePicked={this.handleImagePicked} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withReduxModal(BannerImage)



// WEBPACK FOOTER //
// ./src/components/templates/banner-item/BannerImage.js